export default __webpack_public_path__ + "static/media/download-switch-icon-disable.c98e391e.svg";